const frontendServerUrls = {
  local: 'https://startpluslocal.castandcrew.com:9495',
  qa: 'https://startplus-web-qa1.dev.aws.castandcrew.com',
  uat: 'https://startplus-stg2.us-west-2.dev.aws.castandcrew.com',
  aut: 'https://startplus-stg2.us-west-2.dev.aws.castandcrew.com',
  demo: 'https://demo.startplus.castandcrew.com',
  extuat: 'https://ext-uat.startplus.castandcrew.com',
  prod: 'https://startplus.castandcrew.com',
};

const getOfferUrl = offerId => {
  const currentEnv = process.env.REACT_APP_ENVIRONMENT || 'prod';
  const onboarding = offerId
    ? `/onboarding/offers/${offerId}/details`
    : '/onboarding';

  return frontendServerUrls[currentEnv] + onboarding;
};

export { getOfferUrl };
